const signupErrorMessage = {
  'default': { 'includeEmail': true, 'message': 'signUp.form.submitError' },
  'globalhealth': { 'includeEmail': false, 'message': 'signUp.form.submitError.globalHealth' },
}

export const getSignupErrorMessage = org => {
  if (org in signupErrorMessage) return signupErrorMessage[org]
  else return signupErrorMessage['default']
}
